import { useNavigate } from 'react-router-dom';
import { Button } from 'components/common/Button';
import routeNames from 'router/routeNames.json';
import { Trans } from '@lingui/react/macro';
import classNames from 'classnames';
import { FullSize } from '../../helpers/translation/FullSize.translation';
import { Colour } from '../../helpers/translation/Colour.translation';

const buttonClasses =
  'py-1.5 md:py-2.5 !px-3.5 md:!px-6 !rounded-lg md:!rounded-xl !text-sm md:!text-2xl';

export const BuyDialogSuccess = ({
  shoppingItem,
  product,
  isFreeTee,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div
        className={classNames(
          'bg-qw-blue-500 text-white text-center py-2 md:pt-5 md:pb-2.5',
          {
            'bg-black': isFreeTee,
          }
        )}
      >
        <header
          className={classNames(
            'font-bold text-3xl md:text-5xl uppercase md:mb-2',
            {
              'text-qw-red': isFreeTee,
            }
          )}
        >
          <Trans>Added to cart!</Trans>
        </header>
        <p className="text-xs md:text-xl">
          {shoppingItem.qty} x "{product.name}" -{' '}
          <FullSize size={shoppingItem?.size} />{' '}
          {shoppingItem?.colourHuman && shoppingItem.colourHuman !== 'None' && (
            <>
              (<Colour color={shoppingItem.colour} />)
            </>
          )}
        </p>
      </div>
      <div className="text-center mt-3 md:mt-5">
        <Button
          type="button"
          variant="black"
          size="lg"
          className={classNames(buttonClasses, { 'bg-black': isFreeTee })}
          onClick={() =>
            navigate(`${routeNames.checkout}${routeNames.checkoutForm}`)
          }
        >
          <Trans>CHECKOUT</Trans>
        </Button>
        <span className="mx-1 md:mx-1.5 text-xs md:text-xl">
          <Trans>or</Trans>
        </span>
        <Button
          type="button"
          variant="black"
          size="lg"
          className={classNames(buttonClasses, { 'bg-black': isFreeTee })}
          onClick={onClose}
        >
          <Trans>CONTINUE SHOPPING</Trans>
        </Button>
      </div>
    </div>
  );
};
